import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "simple-tab" }
const _hoisted_2 = { class: "ext" }

import { ref } from 'vue'
import { domutil } from '@/libs/index'
// 定义属性
const currentClassName = 'current'

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleTab',
  props: {
  activeType: {
    type: String,
    required: false,
  },
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const findNerestDom = (current: any, root: any) => {
  if (current && current.parentNode == root) {
    return current
  } else {
    while (true) {
      current = current.parentNode
      if (current.parentNode == root) {
        return current
      }
      if (!current || current == document.body) {
        break
      }
    }
  }
  return null
}
const tabs = ref(null)
const contents = ref(null)
const highlight = (index: number) => {
  const tabElements = Array.from((tabs.value as any).childNodes).filter(
    (item: any) => item.nodeType == 1
  )
  const contentElements = Array.from((contents.value as any).childNodes).filter(
    (item: any) => item.nodeType == 1
  )
  tabElements.map(item => {
    domutil.removeClass(item, currentClassName)
  })
  contentElements.map(item => {
    domutil.removeClass(item, currentClassName)
  })
  domutil.addClass(tabElements[index], currentClassName)
  domutil.addClass(contentElements[index], currentClassName)
}
const checkOnSelectItem = (e: MouseEvent) => {
  if (props.activeType == 'hover' && e.type != 'mouseover') {
    return
  }
  if (props.activeType == 'click' && e.type != 'click') {
    return
  }
  const dom = findNerestDom(e.target, tabs.value)
  if (dom) {
    const childs = Array.from((tabs.value as any).childNodes).filter(
      (item: any) => item.nodeType == 1
    )
    const index = childs.indexOf(dom)
    if (index > -1) {
      highlight(index)
      emit('change', index)
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "ext")
    ]),
    _createElementVNode("div", {
      class: "tabs",
      ref_key: "tabs",
      ref: tabs,
      onClick: checkOnSelectItem,
      onMouseover: checkOnSelectItem
    }, [
      _renderSlot(_ctx.$slots, "tabs")
    ], 544),
    _createElementVNode("div", {
      class: "contents",
      ref_key: "contents",
      ref: contents
    }, [
      _renderSlot(_ctx.$slots, "contents")
    ], 512)
  ]))
}
}

})